import { useTranslationWithPrefix } from '@hotjar/translations';
import { ManageSubscriptionButton } from '~/subscription-management/components';

interface Props {
  onClick(): void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const ReviewOrderFooter = ({ onClick, isDisabled, isLoading }: Props): JSX.Element => {
  const { t: tFooter } = useTranslationWithPrefix('checkout:footer');

  return (
    <ManageSubscriptionButton isDisabled={isDisabled} isLoading={isLoading} onClick={onClick}>
      {tFooter('review-order')}
    </ManageSubscriptionButton>
  );
};
